
import { Vue, Component } from "vue-property-decorator";

@Component
export default class ClientMetrics extends Vue {
  get metrics(): Record<string, number> {
    return this.$store.state.metrics;
  }
}
